import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import './Clients.less';

import ClientsList from './Clients';
import ViewClient from './ViewClient';

function PropertiesPage(props) {
  const {
    match: { url }
  } = props;

  return (
    <Switch>
      <Route exact path={`${url}/`} component={ClientsList} />
      <Route path={`${url}/:id/`} component={ViewClient} />
    </Switch>
  );
}

PropertiesPage.propTypes = {
  match: PropTypes.object
};

export default PropertiesPage;
